module.exports = __webpack_public_path__ + "media/images/icons/filled/pie-chart-fd6bd5deaa25988b32999b1b779cf1fb.svg";